<template>
  <VTooltip>
    <button
      type="button"
      class="btn btn-link p-0 behaviour-point-history-notes-btn"
      :aria-label="notesAriaLabel"
      :data-testid="testId"
    >
      <i class="ri-message-2-line" aria-hidden="true" />
    </button>
    <template #popper>
      <span class="behaviour-point-history-notes-tooltip">{{
        tooltipMessage
      }}</span>
    </template>
  </VTooltip>
</template>

<script>
import { computed } from "vue"
import { useI18n } from "vue-i18n"

export default {
  name: "BehaviourPointHistoryNotesIcon",
  props: {
    notes: {
      type: String,
      default: ""
    },
    rowId: {
      type: [String, Number],
      default: null
    }
  },
  setup(props) {
    const { t } = useI18n()

    const notesText = computed(() => String(props.notes ?? "").trim())

    const hasNotes = computed(() => Boolean(notesText.value))

    const tooltipMessage = computed(() =>
      hasNotes.value ? notesText.value : t("behaviour_manage.notes_not_found")
    )

    const notesAriaLabel = computed(() =>
      hasNotes.value
        ? t("behaviour_manage.notes_tooltip_aria_label", {
            notes: notesText.value
          })
        : t("behaviour_manage.notes_not_found_aria_label")
    )

    const testId = computed(
      () => `behaviour-point-history-notes-${props.rowId ?? "row"}`
    )

    return {
      tooltipMessage,
      notesAriaLabel,
      testId
    }
  }
}
</script>
